import React from 'react';
import styles from "./OverviewProductShimmer.module.scss";

const OverviewProductShimmer = () => {
    return (
        <>
            <div className={styles.product}>
                <div className={`${styles.product_img} dark_shimmer`} />
                <div className='flex-grow-1'>
                    <h3><span className={`${styles.name} dark_shimmer`} /> <span className={`${styles.close_btn} dark_shimmer`} /></h3>
                    <p className={`${styles.price} dark_shimmer`} />
                    <div className={styles.qty}>
                        <span className={`${styles.total} dark_shimmer`} />
                        <span className={`${styles.total} dark_shimmer`} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default OverviewProductShimmer
